const mutations = {
  UPDATE_FORM_COMPLETED(state, formCompleted) {
    state.formCompleted = formCompleted;
  },
  UPDATE_ID(state, id) {
    state.id = id
  },
  UPDATE_YEAR(state, year) {
    state.year = year
  },
  UPDATE_CERTIFICATE_TYPE(state, certificateType) {
    state.certificateType = certificateType
  },
  UPDATE_SUBJECT_ID(state, subjectId) {
    state.subjectId = subjectId
  },
  UPDATE_GRADE(state, grade) {
    state.grade = grade
  },
}

const actions = {
  updateFormCompleted({
    commit
  }, formCompleted) {
    commit('UPDATE_FORM_COMPLETED', formCompleted)
  },
  updateId({
    commit
  }, id) {
    commit('UPDATE_ID', id);
  },
  updateYear({
    commit
  }, year) {
    commit('UPDATE_YEAR', year);
  },
  updateCertificateType({
    commit
  }, certificateType) {
    commit('UPDATE_CERTIFICATE_TYPE', certificateType);
  },
  updateSubjectId({
    commit
  }, subjectId) {
    commit('UPDATE_SUBJECT_ID', subjectId);
  },
  updateGrade({
    commit
  }, grade) {
    commit('UPDATE_GRADE', grade);
  }
}

const getters = {
  FormCompleted: state => {
    return state.formCompleted
  },
  Id: state => {
    return state.id
  },
  Year: state => {
    return state.year
  },
  CertificateType: state => {
    return state.certificateType
  },
  SubjectId: state => {
    return state.subjectId
  },
  Grade: state => {
    return state.grade
  }
}

export default {
  namespaced: true,
  state() {
    return {
      formCompleted: true,
      id: 0,
      year: 0,
      certificateType: 0,
      subjectId: 0,
      grade: "",
    }
  },
  getters,
  actions,
  mutations
}
